export default __webpack_public_path__ + "static/media/pattern.74240c91.svg";